<template>
    <div class="dropdown-text" @click="redirect">
        <span>{{ resource.trajectory_project.name }}</span><br>
        <small>{{ resource.customer_number_according_to_client }} - {{
                [
                    resource.relation.title !== 'other' ? uLang(`app.${resource.relation.title}`) : '',
                    resource.relation.first_name,
                    resource.relation.prefix,
                    resource.relation.last_name
                ].join(' ')
            }}</small>
    </div>
</template>

<script>
import globalSearch from "~/mixins/global-search";

export default {
    name: "trajectory-enrolments-result.vue",
    mixins: [globalSearch],
    computed: {
        redirectName: function () {
            return `admin.relations.trajectory-enrolments.view`
        },
        redirectParams: function () {
            return {
                relationId: this.resource.relation.id,
                trajectoryEnrolmentId: this.resource.id
            }
        }
    }
}
</script>

<style scoped>

</style>
